import axios from "axios";
import fetch from 'node-fetch';

import { TokenService } from "./auth/storage.services";

const GatewayService = {
  baseUrl: '',

  init(baseURL) {
    this.baseURL = baseURL;
  },

  setHeader() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const site = parts.length === 4 ? parts[0] : 'maisenvios';

    axios.defaults.headers.common.Authorization = `Bearer ${TokenService.getToken()}`;
    axios.defaults.headers.common["Content-Type"] =
      "application/json; charset=UTF-8";
    axios.defaults.headers.common["Accept"] =
      "application/json;v=1";
    axios.defaults.headers.common["X-Mais-Host"] = site;
  },
  removeHeader() { },

  get(resource) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.baseURL}${resource}`)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error.response.data.message, error.response.status);
        });
    });
  },

  post(resource, data, headers) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.baseURL}${resource}`, data, { headers: headers })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error, e) {
          if (error && error.response && error.response.data) {
            if (Array.isArray(error.response.data)) {
              reject(error.response.data.join("\n"));
            } else if (
              error.response.data.error &&
              Array.isArray(error.response.data.error)
            ) {
              reject(error.response.data.error.join("\n"));
            } else {
              reject(error.response.data.message);
            }
          } else {
            reject(error);
          }
        });
    });
  },

  download(resource, data, headers) {
    return new Promise((resolve, reject) => {
      axios
        .post(resource, data, { responseType: "blob", headers: headers })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          if (error && error.response && error.response.data) {
            reject(error.response.data.message);
          } else {
            reject(error);
          }
        });
    });
  },

  put(resource, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${this.baseURL}${resource}`, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          if (error && error.response && error.response.data) {
            if (
              error.response.data.error &&
              Array.isArray(error.response.data.error)
            ) {
              reject(error.response.data.error.join("\n"));
            } else {
              reject(error.response.data.message);
            }
          } else {
            reject(error);
          }
        });
    });
  },

  patch(resource, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${this.baseURL}${resource}`, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          if (error && error.response && error.response.data) {
            if (
              error.response.data.error &&
              Array.isArray(error.response.data.error)
            ) {
              reject(error.response.data.error.join("\n"));
            } else {
              reject(error.response.data.message);
            }
          } else {
            reject(error);
          }
        });
    });
  },
  delete(resource) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${this.baseURL}${resource}`)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error.response.data.message);
        });
    });
  },

  customRequest(url, data) {
    return new Promise((resolve, reject) => {
      fetch(url, data).then(function (response) {
        console.log('response', response)
        resolve(response);
      })
        .catch(function (error) {
          console.log('catch', error)
          reject(error.response.data.message);
        })
    });
  },
};

export default GatewayService;

